import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../components/common/PageHeader';

export default function PrivacyPolicy({ embedded = false }) {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 640);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{ minHeight: embedded ? 'auto' : '100vh', background: embedded ? 'transparent' : 'linear-gradient(180deg, #eef4f9 0%, #f0faf9 15%, #f8fffe 40%, #ffffff 100%)', paddingBottom: embedded ? 0 : '80px', width: '100%', overflowX: 'clip', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            {/* Header */}
            <div style={{
                display: embedded ? 'none' : 'block',
                background: 'linear-gradient(135deg, #4e8bca 0%, #6a9fd3 60%, #9cc2e6 100%)',
                padding: isMobile ? '28px 20px 32px' : '36px 32px 40px', borderRadius: '0 0 32px 32px',
                position: 'relative', overflow: 'hidden'
            }}>
                <div style={{ position: 'absolute', top: '-30px', right: '-20px', width: '120px', height: '120px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
                <div style={{ position: 'absolute', bottom: '-40px', left: '30px', width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />

                <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <BackButton onClick={() => navigate(-1)} label="返回上一頁" />
                    <div>
                        <h1 style={{ fontSize: isMobile ? '1.5rem' : '1.75rem', fontWeight: '800', color: '#ffffff', margin: '0 0 2px 0', letterSpacing: '-0.02em', textShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                            隱私權政策
                        </h1>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem', margin: 0 }}>
                            了解我們如何保護您的個人資料
                        </p>
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: embedded ? 0 : '0 16px' }}>
                <div style={{ maxWidth: embedded ? 'none' : '800px', margin: embedded ? 0 : '24px auto 0' }}>
                    <div style={{ background: 'white', padding: embedded ? '24px' : '32px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                        <h1 style={{ color: '#1f2937', marginBottom: '24px', borderBottom: '2px solid #4e8bca', paddingBottom: '12px' }}>隱私權政策 (Privacy Policy)</h1>

                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            歡迎使用 JoinU (揪遊)。我們非常重視您的隱私，特此說明我們對您個人資料的收集、使用與保護原則。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>1. 資料收集</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            我們僅收集為提供交友及活動社群服務所需的最小必要資訊，包含但不限於：姓名／暱稱、電子郵件、個人頭像、生日、城市、系統授權識別碼、興趣標籤，以及您所發起或參加之活動與留言紀錄。請注意：您於活動留言、公開個人檔案等處主動提供之資訊，將視為您自行公開之資料，其他使用者均可瀏覽，請斟酌揭露內容。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>2. 資料使用方式</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            您的資料將用於：建立與管理個人帳號、呈現於平台供其他用戶瀏覽以促進認識與互動、統計與分析平台流量以優化服務。我們絕不會將您的個人資料販售予任何第三方，亦不會用於廣告追蹤或行為分析。若本服務因合併、收購或重整而須將您的個人資料移轉予新的營運主體，我們將於移轉時通知您新適用的隱私權政策。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>3. 第三方服務</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            為提供服務，我們使用第三方雲端服務進行資料儲存與登入驗證（您可選擇以 Google 或 Apple 帳號登入）。這些服務商有其各自的隱私政策，我們僅於提供服務所必要之範圍內與其分享資料。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>4. Cookie 與追蹤技術</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本應用程式不使用廣告追蹤技術，亦不向廣告商或資料仲介商分享您的個人資料。我們僅使用維持登入狀態所必要的 Session Token。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>5. 資料安全防護</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            我們採取合理之技術與組織措施保護您的個人資料，包括加密傳輸與嚴格的資料存取控制。系統亦可能基於安全與防詐目的記錄登入紀錄。惟網際網路資料傳輸無法保證絕對安全，請您妥善保管自己的登入方式，切勿將帳號提供給第三人；使用公用裝置後請務必登出。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>6. 資料保留期限</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            您的個人資料將在帳號存續期間保留。執行「刪除帳號」後，您的個人檔案、留言紀錄及活動資料將於30天內自我們的伺服器永久刪除。備份資料將於90天內完全清除。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>7. 您的個人資料權利</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            依個人資料保護法之規定，您就您的個人資料享有：查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集／處理／利用、以及請求刪除之權利。您可直接於「我的個人資料」頁面查閱與更正大部分資料；進入「帳號安全」頁面即可執行「徹底刪除帳號」，此操作將永久清除您的所有資料且無法復原。如需行使其他權利（如資料匯出），請聯繫我們：<strong>service@joinuworld.com</strong>，我們將於收悉您的請求後儘速處理。另外，當司法、警察或其他有權機關基於法定調查程序要求時，我們可能依法提供您的相關資料。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>8. 年齡限制</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本服務僅供18歲（含）以上人士使用。若我們發現未成年用戶，將立即停用其帳號並刪除相關資料。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>9. 政策變更</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本政策如有重大修訂（例如資料使用方式之變更），我們將透過站內通知或電子郵件告知您，並於本頁更新「最後更新日期」。若您於變更後繼續使用本服務，視為您同意修改後之內容。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>10. 聯絡我們</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            如對本隱私政策有任何疑問或希望行使您的資料權利，請透過以下方式聯繫我們：<br />
                            電子郵件：<strong>service@joinuworld.com</strong>
                        </p>

                        <p style={{ marginTop: '40px', fontSize: '13px', color: '#9ca3af', textAlign: 'center' }}>
                            最後更新日期：2026年7月
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
